import { AdminRequest } from "./AdminRequest";
import { ClientInfoReply } from "./ClientInfoReply";
import { Logger } from "../logging/Logger";
import { LogManager } from "../logging/LogManager";
import { MessageSender } from "../messaging/MessageSender";
import { StringUtil } from "../StringUtil";

export class ClientInfoRequest extends AdminRequest {
    private static log: Logger;
    companyFilter: string;
    isDetail: boolean;
    replyToQueue: string;
    sessionIdFilter: string;
    swingOnly: boolean;
    userIdFilter: string;

    constructor(message: any) {
        super(message);
        this.companyFilter = message.companyFilter;
        this.isDetail = message.isDetail;
        this.replyToQueue = message.replyToQueue;
        this.sessionIdFilter = message.sessionIdFilter;
        this.swingOnly = message.swingOnly;
        this.userIdFilter = message.userIdFilter;
    }

    override isForMe(): boolean {
        if (this.swingOnly === true) {
            // this messages are intended to be handled by Classic clients only
            return false;
        }
        return super.isForMe();
    }

    override handle(): void {
        if (StringUtil.isEmptyString(this.replyToQueue)) {
            ClientInfoRequest.getLog().debug("Cannot reply to client info request; no reply queue specified");
            return;
        }
        const response = new ClientInfoReply(this.isDetail);
        const className = "com.tms.common.lib.clientadmin.ClientInfoReply";
        MessageSender.getInstance().send(this.replyToQueue, false, response, className);
    }

    private static getLog(): Logger {
        if (this.log == null)
            this.log = LogManager.getLogger("core.client.ClientInfoRequest");
        return this.log;
    }
}
